module.exports = __webpack_public_path__ + "public/static/Noresultfound.svg?99ad2f90";